<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>

<section>
  <div class="row no-mar-lr mar-tb-20">
    <div class="col-md-5">
      <span class="dta_title">{{'Jun View' | translate}}</span>
    </div>

    <div class="col-md-7 pad-top-10 text-right">
      <a href="#/poFCMonthly" class="has-link">{{'Monthly View' | translate}}</a> |
      <a href="#/poFCJun" class="has-link">{{'Jun View' | translate}}</a> |
      <a href="#/poFCDaily" class="has-link">{{'Daily View' | translate}}</a> |
      <a href="#/poSummary" class="has-link">{{'Package Data Availability' | translate}}</a> |
      <a href="#/poDashboard" class="has-link">Back&nbsp;
        <i class="fa fa-reply" aria-hidden="true"></i>
      </a>
    </div>
  </div>

  <ul class="nav nav-tabs pad-top-40" role="tablist">
    <li class="nav-item" (click)="resetDD()">
      <a class="nav-link active" data-toggle="tab" href="#tableView" role="tab" #unlistDPNav>{{'Table View' | translate}}</a>
    </li>
    <li class="nav-item" (click)="resetDD()">
      <a class="nav-link" data-toggle="tab" href="#graphView" role="tab" #createDPNav>{{'Graph View' | translate}}</a>
    </li>
  </ul>

  <div class="tab-content">
    <div class="tab-pane active" id="tableView" #unlistDPPane>
      <section class="part_search_bar">
        <div class="row no-mar-lr">
          <div class="col-md-4 pad-top-30">
            <div class="row">
              <div class="col-md-5 text-right pad-top-5">
                {{'SUPPLIERCODE' | translate}} &nbsp;&nbsp;&nbsp;
              </div>
              <div class="col-md-5">
                <ng-multiselect-dropdown *ngIf="suppDD" #suppliercodeTbl="ngModel" name="suppliercodetbl"[(ngModel)]="suppCodeTbl"
                [settings]="dropdownSettings" [data]="suppDD"  (onSelect)="onSupplierCodeSelect($event)" (onDeSelect)="OnSupplierCodeDeSelect($event)"
                  (onSelectAll)="onSupplierCodeSelectAll($event)" (onDeSelectAll)="onSupplierCodeDeSelectAll($event)">
                </ng-multiselect-dropdown>
              </div>
            </div>
          </div>
          <div class="col-md-4 pad-top-30">
            <div class="row">
              <div class="col-md-5 text-right pad-top-5">
                {{'Location Code' | translate}} &nbsp;&nbsp;&nbsp;
              </div>
              <div class="col-md-5">
                <ng-multiselect-dropdown *ngIf="locDD" #locationcodeTbl="ngModel" name="locationcodeTbl"  [(ngModel)]="locCodeTbl"
                [settings]="dropdownSettings" [data]="locDD">
                </ng-multiselect-dropdown>
              </div>
            </div>

          </div>
          <div class="col-md-3 pad-top-30">
            <button class="btn btn btn-dark" (click)="onChangeTable(config)">{{'Display' | translate}}</button>
          </div>
        </div>
      </section>
      <div class="row no-mar-lr mar-top-50">
        <div class="container">
          <div class="row">
            <div class="col-md-6" *ngIf="cycleDetails !== undefined && cycleDetails.response !== undefined && this.cycleLength>0">
              <div class="pt21">
                <p class="pb1">Jun 1: {{'Cycle' | translate}}:
                  <strong>{{cycleDetails.response.content[0].forcast1Cycle}}</strong>
                  , {{'Month' | translate}}:
                  <strong>{{cycleDetails.response.content[0].forcast1Month}}</strong>
                  , {{'Year' | translate}}:
                  <strong>{{cycleDetails.response.content[0].forcast1Yr}}</strong>
                </p>
                <p class="pb1">
                  Jun 2: {{'Cycle' | translate}}:
                  <strong>{{cycleDetails.response.content[0].forcast2Cycle}}</strong>
                  , {{'Month' | translate}}:
                  <strong>{{cycleDetails.response.content[0].forcast2Month}}</strong>
                  , {{'Year' | translate}}:
                  <strong>{{cycleDetails.response.content[0].forcast2Yr}}</strong>
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page" [totalItems]="length" [itemsPerPage]="itemsPerPage"
                [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
              </pagination> -->

            </div>
          </div>
          <!-- <ng-table [config]="config" (tableChanged)="onChangeTable(config)" [rows]="rows" [columns]="columns">
          </ng-table> -->

          <pagination *ngIf="config.paging" class="pad-top-10" [(ngModel)]="page" [totalItems]="length" [itemsPerPage]="itemsPerPage"
                [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
              </pagination>

          
          
          <div class="example-container ">
          
            <!-- <mat-table [dataSource]="dataSource" matSort>
          
             
              <ng-container matColumnDef="supplierCode">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Code </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.supplierCode}} </mat-cell>
              </ng-container>
          
              <ng-container matColumnDef="supplierName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.supplierName}} </mat-cell>
              </ng-container>
                     
              <ng-container matColumnDef="specification">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Specification </mat-header-cell>
                <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.specification}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="location">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Location </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.location}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Jun1">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Jun 1</mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.fc1}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Jun2">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Jun 2 </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.fc2}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Jun3">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Jun 3 </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.fc3}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Jun4">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Jun 4 </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.fc4}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Jun5">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Jun 5 </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.fc5}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Jun6">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Jun 6 </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.fc6}} </mat-cell>
              </ng-container>
          
              
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;">
              </mat-row>
            </mat-table> -->
            <table>
              <th>Supplier Code</th>
              <th>Supplier Name</th>
              <th>Specification</th>
              <th>Location</th>
              <th>Jun 1</th>
              <th>Jun 2</th>
              <th>Jun 3</th>
              <th>Jun 4</th>
              <th>Jun 5</th>
              <!-- <th>Jun 6</th> -->
              <tr *ngFor="let row of data">
                <td>{{row.supplierCode}}</td>
                <td>{{row.supplierName}}</td>
                <td><div [innerHTML]="row.specification"></div></td>
                <td>{{row.location}}</td>
                <td style="min-width: 100px;"><div [innerHTML]="row.fc1"></div></td>
                <td style="min-width: 100px;"><div [innerHTML]="row.fc2"></div></td>
                <td style="min-width: 100px;"><div [innerHTML]="row.fc3"></div></td>
                <td style="min-width: 100px;"><div [innerHTML]="row.fc4"></div></td>
                <td style="min-width: 100px;"><div [innerHTML]="row.fc5"></div></td>
                <!-- <td><div [innerHTML]="row.fc6"></div></td> -->
              </tr>
            </table>
          
           
            </div>
          </div>
          <!-- <ng-table [config]="config" (tableChanged)="onChangeTable(config)" [rows]="rows" [columns]="columns">
          </ng-table> -->
          <div class="noRecords" *ngIf="rows.length == 0"> {{'No Records Found' | translate}}! </div>
        </div>
      </div>
    </div>
    <div class="tab-pane" id="graphView" #createDPPane>
      <section class="part_search_bar">
        <div class="row no-mar-lr">
          <div class="col-md-4 pad-top-30">
            <div class="row">
              <div class="col-md-5 text-right pad-top-5">
                {{'SUPPLIERCODE' | translate}} &nbsp;&nbsp;&nbsp;
              </div>
              <div class="col-md-5">
                <p-dropdown [options]="graphSuppDD" [(ngModel)]="supPoint" [filter]="true" [style]="{'width':'100%'}" (onChange)="onGraphSuppSel($event)"
                  placeholder="Select Supplier Code"></p-dropdown>
              </div>
            </div>
          </div>
          <div class="col-md-4 pad-top-30">
            <div class="row">
              <div class="col-md-5 text-right pad-top-5">
                {{'Location Code' | translate}} &nbsp;&nbsp;&nbsp;
              </div>
              <div class="col-md-5">
                <ng-multiselect-dropdown *ngIf="locDD" #locationcodeGrph="ngModel" name="locationcodeGrph"  [(ngModel)]="locCode"
                [settings]="graphLocStg" [data]="locDD">
                </ng-multiselect-dropdown>
              </div>
            </div>
          </div>
          <div class="col-md-3 pad-top-30">
            <button class="btn btn btn-dark" (click)="showGraphData()" [disabled]="graphDispBtn">{{'Display' | translate}}</button>
          </div>
        </div>
      </section>
      <section class="container-fluid">
        <div class="row" *ngIf="cycleDetails !== undefined && cycleDetails.response !== undefined && this.cycleLength>0">
          <div class="pt21 col-md-3">
            <p class="pb1">Jun 1: {{'Cycle' | translate}}:
              <strong>{{cycleDetails.response.content[0].forcast1Cycle}}</strong>
              , {{'Month' | translate}}:
              <strong>{{cycleDetails.response.content[0].forcast1Month}}</strong>
              , {{'Year' | translate}}:
              <strong>{{cycleDetails.response.content[0].forcast1Yr}}</strong>
            </p>
            <p class="pb1">
              Jun 2: {{'Cycle' | translate}}:
              <strong>{{cycleDetails.response.content[0].forcast2Cycle}}</strong>
              , {{'Month' | translate}}:
              <strong>{{cycleDetails.response.content[0].forcast2Month}}</strong>
              , {{'Year' | translate}}:
              <strong>{{cycleDetails.response.content[0].forcast2Yr}}</strong>
            </p>
          </div>
          <div class="col-md-4 pt21" *ngIf="resultData != undefined">
            <strong>{{'SUPPNAME[Eng]' | translate}} : {{resultData.supplierNameEN}}</strong>
          </div>
          <div class="col-md-4 pt21" *ngIf="resultData != undefined">
            <strong>{{'SUPPNAME[Jap]' | translate}}: {{resultData.supplierNameJP}}</strong>
          </div>
        </div>
      </section>
      <div class="no-mar-lr container">
        <div class="row">
          <div class="col-md-6">
            <div class="card mar-top-40">
              <div class="card-header bgWhite">
                <b class="card-title">{{'Volume' | translate}} (m3)</b>
              </div>
              <div class="card-body">
                <div *ngIf="VolumeChartData.length > 0">
                  <canvas baseChart *ngIf="VolumeChartData" [datasets]="VolumeChartData" [labels]="thirdLabels" [options]="chartOpt" [legend]="barChartLegend"
                    [colors]="lineChartColors" [chartType]="barChartType"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mar-top-40">
              <table class="table table-bordered">
                  <thead class="bg-gray">
                    <tr>
                      <th class="text-center">{{'Location' | translate}}</th>
                      <th class="text-center">Jun 1</th>
                      <th class="text-center">Jun 2</th>
                      <th class="text-center">Jun 3</th>
                      <th class="text-center">Jun 4</th>
                      <th class="text-center">Jun 5</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of junData">
                      <td class="text-center">{{data.locationName}}</td>
                      <td class="text-center">{{data.jun1Volume | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun2Volume | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun3Volume | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun4Volume | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun5Volume | number : '1.2-2'}}</td>
                    </tr>
                  </tbody>
                </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="panel panel-default mar-top-40">
              <div class="panel-heading bgWhite">
                <b class="panelTitle">{{'Weight' | translate}} (Kg)</b>
              </div>
              <div class="panel-body">
                <div *ngIf="WeightChartData.length > 0">
                  <canvas baseChart *ngIf="WeightChartData" [datasets]="WeightChartData" [labels]="thirdLabels" [options]="chartOpt" [legend]="barChartLegend"
                    [colors]="lineChartColors" [chartType]="barChartType"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mar-top-40">
              <table class="table table-bordered">
                  <thead class="bg-gray">
                    <tr>
                      <th class="text-center">{{'Location' | translate}}</th>
                      <th class="text-center">Jun 1</th>
                      <th class="text-center">Jun 2</th>
                      <th class="text-center">Jun 3</th>
                      <th class="text-center">Jun 4</th>
                      <th class="text-center">Jun 5</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of junData">
                      <td class="text-center">{{data.locationName}}</td>
                      <td class="text-center">{{data.jun1Weight | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun2Weight | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun3Weight | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun4Weight | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun5Weight | number : '1.2-2'}}</td>
                    </tr>
                  </tbody>
                </table>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="panel panel-default mar-top-40">
              <div class="panel-heading bgWhite">
                <b class="panelTitle">{{'Quantity' | translate}}</b>
              </div>
              <div class="panel-body">
                <div *ngIf="QuantityChartData.length > 0">
                  <canvas baseChart *ngIf="QuantityChartData" [datasets]="QuantityChartData" [labels]="thirdLabels" [options]="chartOpt" [legend]="barChartLegend"
                    [colors]="lineChartColors" [chartType]="barChartType"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mar-top-40">
              <table class="table table-bordered">
                  <thead class="bg-gray">
                    <tr>
                      <th class="text-center">{{'Location' | translate}}</th>
                      <th class="text-center">Jun 1</th>
                      <th class="text-center">Jun 2</th>
                      <th class="text-center">Jun 3</th>
                      <th class="text-center">Jun 4</th>
                      <th class="text-center">Jun 5</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of junData">
                      <td class="text-center">{{data.locationName}}</td>
                      <td class="text-center">{{data.jun1Quantity | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun2Quantity | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun3Quantity | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun4Quantity | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.jun5Quantity | number : '1.2-2'}}</td>
                    </tr>
                  </tbody>
                </table>
          </div>
        </div>
      </div>
    </div>
</section>